import type { SkillTemplate } from './issue-log-xref.js';
import { issueLogXrefTemplate } from './issue-log-xref.js';
import { browserTestingTemplate } from './browser-testing.js';
import { agentTasksTemplate } from './agent-tasks.js';
import { canaryBasicTemplate } from './canary-basic.js';
import { testCasesTemplate } from './test-cases.js';
import { debugRunTemplate } from './debug-run.js';
import { sandboxTemplate } from './sandbox.js';

// SkillTemplate kept file-local (defined in issue-log-xref.ts)

export const SKILL_TEMPLATES: Record<string, SkillTemplate> = {
  'canary-basic': canaryBasicTemplate,
  'agent-tasks': agentTasksTemplate,
  'issue-log-xref': issueLogXrefTemplate,
  'browser-testing': browserTestingTemplate,
  'test-cases': testCasesTemplate,
  'debug-run': debugRunTemplate,
  'sandbox': sandboxTemplate,
};
